import { render, staticRenderFns } from "./SettingLaravelSync.vue?vue&type=template&id=83061442&scoped=true"
import script from "./SettingLaravelSync.vue?vue&type=script&lang=js"
export * from "./SettingLaravelSync.vue?vue&type=script&lang=js"
import style0 from "./SettingLaravelSync.vue?vue&type=style&index=0&id=83061442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83061442",
  null
  
)

export default component.exports